
<!-- Pulsante senza menu -->
<button mat-button
        *ngIf="isInfoEmpty"
        class="se-header-info-more-button"
        [disabled]="true"
        [class.se-header-info-more-button-no-menu]="isInfoEmpty">
    <div style="display:flex;flex-direction:column">
        <div class="se-header-info-main-description"
                [class.se-header-info-multiline-main-description]="isMultilineButton">
            {{info.mainDescription}}
        </div>
        <div class="se-header-info-secondary-description"
                *ngIf="isMultilineButton">
            {{info.secondaryDescription}}
        </div>
    </div>

</button>

<div *ngIf="!isInfoEmpty">
    <!-- Pulsante con informazioni in menu menu -->
    <button mat-button
            [matMenuTriggerFor]="menuInfo"
            class="se-header-info-more-button">
        {{info.mainDescription}}
        <mat-icon class="se-header-info-header-more-icon">more_vert</mat-icon>
    </button>

    <mat-menu #menuInfo="matMenu"
              class="se-header-info-menu-panel"
              yPosition="below"
              xPosition="after">
        <div>
            <div *ngFor="let i of info.infoList">
                <button mat-menu-item class="se-header-toolbar-item-info se-menu-button" disabled>
                    <span translate>{{i.label}}</span><span>: {{i.value}}</span>
                </button>
            </div>
        </div>
    </mat-menu>
</div>

